import { API } from '../config';

export const exportLogs = () => `${API.BASE_DEV_HOST}/api/audit-logs/export`;
